<template>
    <div>
        <div class="container" style="width:100%;">
            <!-- <div style="font-size:20px;"><i class="el-icon-s-unfold grid-con-icon"></i><span style="margin-left:5px;">待办工作</span></div> -->
            <el-form :model="form" inline  style="padding-left:8px;">
                <div style="display:flex;justify-content:flex-end;">
                    <el-button @click="onEditPlanClick(null)" type="primary">新建计划</el-button>
                    <el-button @click="onExportResultClick()" type="primary">导出执行结果</el-button>
                </div>
                <!-- justify="space-between" -->
                <el-row  type="flex" style="margin-top:15px;" align="center">
                    <el-form-item label="执行日期" style="width: 500px;">
                            <el-date-picker
                                    v-model="form.dateArray"
                                    type="daterange"
                                    range-separator="至"
                                    value-format="yyyy-M-d"
                                    start-placeholder="年/月/日"
                                    end-placeholder="年/月/日">
                            </el-date-picker>
                    </el-form-item>
                    <!-- <el-switch
                        v-model="form.isValidDate"
                        active-text="按生效日期"
                        inactive-text="按订单日期">
                    </el-switch>
                     -->
                </el-row>
                <el-row>
                    <el-form-item label="执行状态">
                        <el-select v-model="form.planStatusIdsArr" style="width:400px;" clearable multiple  placeholder="请选择">
                            <el-option v-for="item in doStatusList" :key="item.value" :label="item.label"
                                :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>

                    <!-- <el-form-item label="产品">
                        <el-select v-model="form.productArr" clearable multiple  placeholder="请选择">
                            <el-option v-for="item in productList" :key="item.value" :label="item.label"
                                :value="item.value"></el-option>
                        </el-select>
                    </el-form-item> -->

                    <el-form-item label="关键字">
								<el-input v-model="form.key" class="text-width"></el-input>
					</el-form-item>
                    <!--  -->
                    <el-button @click="onQuery" type="primary">检索</el-button>
                </el-row>
            </el-form>
            <el-table 
                :data="planList.slice((currentPage-1)*PageSize,currentPage*PageSize)" 
                border :header-cell-style="{background:'#eef1f6',color:'#606266'}" height="800"
                        style="width: 80%;margin-top: 10px;" ref="Table" >
                <el-table-column prop="id" align="center" sortable width="50" label="任务编号" ></el-table-column>
                <el-table-column prop="订单编号" align="center" sortable width="130" label="订单编号">
                    <!-- <template slot-scope="scope" >
                         <div :style="{'color':scope.row.delay==1 && scope.row.roleId==1?'red':'black'}">{{scope.row.sheetCode}}</div>
                    </template> -->
                </el-table-column>
                <!-- <el-table-column :key="Math.random()" prop="comeFrom" align="center" width="50" label="来源"></el-table-column> -->
                <!-- <el-table-column prop="订单日期" align="center" width="110" label="订单日期" >
                    <template slot-scope="scope" >
                         {{scope.row.订单日期.split('T')[0]}}
                    </template>
                </el-table-column>  -->
                <!-- <el-table-column prop="经销商简称" align="center" label="经销商简称" ></el-table-column>  -->
                <el-table-column prop="终端客户" align="center" sortable  label="终端客户/经销商" >
                    <template slot-scope="scope" >
                         <span :style="scope.row.agentPlan?'color:red;cursor:pointer;':'color:#2D8CF0;cursor:pointer;'"  @click="onLogListClick(scope.row)">{{scope.row.agentPlan?scope.row.agentPlan+'***':scope.row.终端客户}}</span>
                    </template>
                </el-table-column>
                <!-- <el-table-column prop="产品名称" align="center" sortable label="产品名称" ></el-table-column> -->
                <!-- <el-table-column prop="orderId" align="center" label="订单ID" ></el-table-column> -->
                <el-table-column prop="数量" align="center" sortable width="60" label="数量" ></el-table-column>
                <el-table-column prop="seg" align="center" sortable width="110" label="阶段" ></el-table-column>
                <el-table-column prop="跟进日期" align="center" width="200" label="跟进日期" >
                    <template slot-scope="scope" >
                        {{scope.row.planSDate.split('T')[0]}} 至  {{scope.row.planEDate.split('T')[0]}}
                    </template>
                </el-table-column> 
                <el-table-column prop="topic" align="center" sortable width="170" label="任务主题" ></el-table-column>
                <el-table-column prop="订单状态" align="center" sortable width="80" label="订单状态" ></el-table-column>
                <el-table-column prop="执行状态" align="center" sortable width="110" label="执行状态" >
                    <template slot-scope="scope" >
                        <span :style="scope.row.执行状态=='超期未执行'?'color:red;':
                            scope.row.执行状态=='执行期(未执行)'?'color:#CC3300':
                            scope.row.执行状态=='待执行'?'':'color:gray'">
                            {{scope.row.执行状态=='超期未执行' || scope.row.执行状态=='超期执行'?'***'+scope.row.执行状态:scope.row.执行状态}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="rowTime" align="center" sortable width="160" label="创建时间" ></el-table-column>
                <el-table-column align="center" width="180" label="编辑" >
                    <template slot-scope="scope" >
                        <el-button v-if="!scope.row.finishTime" type="text" @click="onDoClick(scope.row,true)">跟进</el-button>
                        <el-button v-else type="text" @click="onDoClick(scope.row,false)">查看</el-button>
                        <el-button type="text" @click="onEditPlanClick(scope.row)">修改</el-button>                        
                        <el-button type="text" style="color:red;" @click="onDelClick(scope.row)">删除</el-button>
                        <el-button v-if="!scope.row.finishTime" type="text" style="color:blue;" @click="onSetFinishClick(scope.row)">结案</el-button>
                    </template>
                </el-table-column>

                 
                </el-table>

                <div class="tabListPage">
                    <el-pagination @size-change="handleSizeChange" 
                                    @current-change="handleCurrentChange" 
                                    :current-page="currentPage" 
                                    :page-sizes="pageSizes" 
                                    :page-size="PageSize" layout="total, sizes, prev, pager, next, jumper" 
                                    :total="totalCount">
                        </el-pagination>
                </div>

                <el-dialog title="新建/编辑计划" v-if="editDialogVisible" :visible="editDialogVisible" width="60%"
                                :modal-append-to-body='false'
                                :close-on-click-modal='false'
                                @close="editDialogVisible = false" 
                                append-to-body>
                    <edit-plan :cur-item="curItem" @close="editDialogVisible=false" @onHaveDone="setFinishOver"></edit-plan>
                
                </el-dialog>

                <el-dialog :title="setPlanTitle" v-if="doDialogVisible" :visible="doDialogVisible" width="60%"
                                :modal-append-to-body='false'
                                :close-on-click-modal='false'
                                @close="doDialogVisible = false" 
                                append-to-body>
                    <do-plan  :plan-item="curItem" :is-do="isDo" @close="doDialogVisible=false" @onHaveDone="setFinishOver"></do-plan>
                
                </el-dialog>

                <el-dialog title="计划结案" v-if="finishDialogVisible" :visible="finishDialogVisible" width="60%"
                                :modal-append-to-body='false'
                                :close-on-click-modal='false'
                                @close="finishDialogVisible = false" 
                                append-to-body>                    
                    <set-finish :plan-item="curItem" @close="finishDialogVisible=false" @onSetFinishOver="setFinishOver"/>                
                </el-dialog>

                <el-dialog title="服务日志" v-if="logDialogVisible" :visible="logDialogVisible" width="60%"
                            :modal-append-to-body='false'
                            :close-on-click-modal='false'
                            @close="logDialogVisible = false" 
                            append-to-body>                 
                         
                    <history :cur-item="transferItem" @close="logDialogVisible=false" @onDialogClose="setClose"/>                
                </el-dialog>

        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getLatestMonthDateArrayByDate,getNextAndBeforeHalfYearDateArray } from "@/utils/time";
import { getToken } from "@/utils/auth";
import MyUploadFileFormItem from "@/components/MyUploadFileFormItem";
import {getSampleArrayFromSever,getSampleLogStrToSever} from "@/utils/tools";
import {ZC_DelPlan,ZC_SaveResult,ExportMSReport} from "@/api/zc";
import SetFinish from './components/SetFinish.vue';
import DoPlan from './components/DoPlan.vue';
import EditPlan from './components/EditPlan.vue';
import History from './components/History.vue';

export default {
    name: 'baseform',
    components: {
        MyUploadFileFormItem,SetFinish,DoPlan,EditPlan,History
      },
        
    computed: {
        ...mapGetters(['planList','serviceTypeList','clientOrderList','segList','provideList'])
    },
    data() {
        return {
            form: {    
                dateArray:getNextAndBeforeHalfYearDateArray({}),
                // isValidDate:true,
                planStatusIdsArr:['执行期(未执行)','超期未执行','待执行'],
                // productArr:[],
                key:'',
            },
            props: { multiple: true },

            // 默认显示第几页
            currentPage:1,
            // 总条数，根据接口获取数据长度(注意：这里不能为空)
            totalCount:0,
            // 个数选择器（可修改）
            pageSizes:[20,50,100],
            // 默认每页显示的条数（可修改）
            PageSize:20,
            doStatusList:[{label:'执行期(未执行)',value:'执行期(未执行)'},{label:'超期未执行',value:'超期未执行'},{label:'待执行',value:'待执行'},{label:'超期执行',value:'超期执行'},{label:'提前执行',value:'提前执行'},{label:'如期执行',value:'如期执行'}],
            curItem:{},
            editDialogVisible:false,
            
            
            
            // reverse: false,
            doDialogVisible:false,
            // doForm:{
            //     dealDate:'',
            //     content:'',
            //     sampleArr:[],
            // },
            doLog:[],

            finishDialogVisible:false,
            isDo:false,
            setPlanTitle:'计划跟进',

            editForm:{},

            transferItem:{},
            logDialogVisible:false,
        };
    },

    async mounted() {
        this.init();
    },


    methods: {
        async init(){
            await this.$store.dispatch('zc/planStatusList');
            await this.$store.dispatch('zc/clientDictList');
            await this.$store.dispatch('zc/agentDictList');
            await this.$store.dispatch('zc/serviceTypeList');
            await this.$store.dispatch('zc/segList');
            await this.$store.dispatch('zc/provideList');
            this.onQuery();
        },

        async onLogListClick(item){
            if (item.isAgent){
                this.transferItem={id:item.agentId,clientName:item.经销商全称,isAgent:1};
            }else{
                this.transferItem={id:item.companyId,clientName:item.终端客户,isAgent:0};
            }
            
            this.logDialogVisible=true;
        },

        setClose(){
            this.logDialogVisible=false;
        },

        async onEditPlanClick(item){
            // console.log('item',item)
            this.curItem=item;
            this.editDialogVisible=true;
        },

        async onExportResultClick(){
            const {dateArray:[sYM, eYM],planStatusIdsArr,key} = this.form;
            var sDate = new Date(sYM+'').toLocaleDateString();
            var eDate = new Date(eYM+'').toLocaleDateString();
            await ExportMSReport({sDate,eDate});
        },

        

        async onSetFinishClick(item){
            this.curItem=item;
            this.finishDialogVisible=true;
        },

        async setFinishOver(){
            this.onQuery();
            this.finishDialogVisible=false;
            this.doDialogVisible=false;
            this.editDialogVisible=false;
        },

        async onDelClick(item){
            this.$confirm('是否确认删除？ 是否继续?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(async () => {    
                        await ZC_DelPlan({userId: getToken(),id:item.id}).then(()=>{
                        this.onQuery();              
						this.$message.success('删除成功');
					})
                    })
        },

        async onDoClick(item,flag){
            this.isDo=flag;
            if (flag){
                this.setPlanTitle='计划跟进';
            }else{
                this.setPlanTitle='查看计划执行';
            }
            this.curItem=item;
            // this.doLog=[];
            // this.doForm.content='';
            // this.doForm.dealDate='';
            // this.doForm.sampleArr=[];
            // await this.$store.dispatch('zc/resultList',{planId:item.id}).then(()=>{
            //     this.resultList.forEach(ele=>{
            //         var obj={};
            //         var samples = ele.samples;
            //         obj=ele;
            //         obj.sampleArr=getSampleArrayFromSever({samples});
            //         this.doLog.push(obj);
            //     })
                this.doDialogVisible=true;
            // });             
        },
        
        // async onSaveDo(){
        //     const {dealDate,content,sampleArr,provideTypeArr} = this.doForm;
        //     if (!dealDate){
        //         this.$message.warning('选择服务时间')
        //         return;
        //     }
        //     if (!content){
        //         this.$message.warning('请填写服务内容')
        //         return;
        //     }
        //     var provideTypeIds='';
        //     if (provideTypeArr.length>0){
        //         provideTypeIds=provideTypeArr.join(',');
        //     }

        //     var samples = getSampleLogStrToSever({sampleArr})
        //     // console.log('aa',sampleArr,samples)   id,planId,dealDate,dealContent,samples
        //     await ZC_SaveResult({id:'',planId:this.curItem.id,dealDate,dealContent:content,samples,provideTypeIds});
        //     this.$message.success('保存成功');
        //     this.onQuery();
        //     this.doDialogVisible=false;

        // },

        // async onSavePlan(){
        //     const {id,dateArray:[sDate,eDate],companyId,orderId,seg,serviceTypeId,topic, content,remark,sampleArr} = this.editForm;
        //     if (!sDate) {
        //         this.$message.warning('请选择执行日期')
        //         return;
        //     }
        //     if (!companyId) {
        //         this.$message.warning('请选择终端客户')
        //         return;
        //     }
        //     if (!seg ) {
        //         this.$message.warning('请选择服务阶段')
        //         return;
        //     }
        //     if (!serviceTypeId ) {
        //         this.$message.warning('请选择服务类型')
        //         return;
        //     }
        //     if (!topic?.trim()) {
        //         this.$message.warning('请输入服务主题')
        //         return;
        //     }
        //     if (!content?.trim()) {
        //         this.$message.warning('请输入服务内容')
        //         return;
        //     }
        //     var samples = getSampleLogStrToSever({sampleArr})
        //     console.log('aa',sampleArr,samples)
        //     await ZC_SavePlan({id,companyId,orderId,seg,serviceTypeId,planSDate:sDate,planEDate:eDate,topic,content,remark,samples});
        //     this.$message.success('保存成功');
        //     this.onQuery();
        //     this.editDialogVisible=false;
        // },

       async onQuery(){
        console.log('form',this.form)
        const {dateArray:[sYM, eYM],planStatusIdsArr,key} = this.form;
        var statusIds='';
        var sDate = new Date(sYM+'').toLocaleDateString();
        var eDate = new Date(eYM+'').toLocaleDateString();

        if (planStatusIdsArr.length>0){
            statusIds=planStatusIdsArr.join(',');
        }

        // console.log('aa',sDate,eDate,this.productSearchForm);
        await this.$store.dispatch("zc/planList", {
            sDate,
            eDate,
            statusIds,
            key,
        }).then(res=>{
            this.$refs.Table.doLayout();
            this.totalCount=this.planList.length
            this.currentPage=1
            
        });

       },

       // 每页显示的条数
        handleSizeChange(val) {
        // 改变每页显示的条数 
        this.PageSize=val
        // 注意：在改变每页显示的条数时，要将页码显示到第一页
        this.currentPage=1
        },
        // 显示第几页
        handleCurrentChange(val) {
            // 改变默认的页数
            this.currentPage=val
        },


    }
};
</script>

<style scoped>
</style>